import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isFillAccountRequestFailure() {
      return getState().request.isFailure;
    },
    isFillAccountRequestPending() {
      return getState().request.isPending;
    },
    isFillAccountRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getFillAccountError() {
      return getState().error;
    },
  };
}

export { createSelector };
